import type { Body } from './racer-movement';

/**
 * How wide a racer's exhaust flame should be drawn.
 *
 * Spec: docs/exhaust-flame.md
 */

/** Driving forward: the flame at its full painted width. */
export const EXHAUST_FORWARD_SCALE = 1;

/** Holding station: half, so there is always something burning. */
export const EXHAUST_IDLE_SCALE = 0.5;

/** Backing off: a stub, so cutting the throttle reads instantly. */
export const EXHAUST_BACKWARD_SCALE = 0.1;

/**
 * Horizontal speed below which a racer counts as holding station.
 *
 * Drag leaves `vx` twitching around zero forever, so without a band the flame
 * would snap between its widest and narrowest every frame.
 */
export const EXHAUST_DRIFT_VX = 45;

/**
 * The flame's width multiplier, read off actual velocity rather than input.
 *
 * Momentum is the feel of this game: a racer who lets go of forward is still
 * travelling forward for a moment, and the flame should agree with the ship
 * rather than with the keyboard.
 */
export function exhaustScale(body: Body, alive: boolean): number {
  if (!alive) {
    return 0;
  }
  if (body.vx > EXHAUST_DRIFT_VX) {
    return EXHAUST_FORWARD_SCALE;
  }
  if (body.vx < -EXHAUST_DRIFT_VX) {
    return EXHAUST_BACKWARD_SCALE;
  }
  return EXHAUST_IDLE_SCALE;
}
